module.exports = __webpack_public_path__ + "img/SCTLogo.4b175eb5.svg";